<div class="middle-box text-center animated fadeInDown">
  <h1>404</h1>
  Sorry, but the page you are looking for has not been found.
</div>
